<template>
  <wt-table :class="classes" :list="data" :labels="labels" ></wt-table>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-gene-detection-result'

export default {
  name: 'pt-gene-detection-result',
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      labels: [
        {
          label: 'rsID',
          value: 'rsId'
        },
        {
          label: '基因名称',
          value: 'gene',
          maxWidth: 120
        },
        {
          label: '染色体',
          value: 'chromosome',
          maxWidth: 80
        },
        {
          label: '起始物理位置',
          value: 'positionStart'
        },
        {
          label: '终止物理位置',
          value: 'positionEnd'
        },
        {
          label: '检测项中文',
          value: 'detectionItemChineseName',
          minWidth: 200
        },
        {
          label: '致病性等级',
          value: 'causalRank'
        },
        {
          label: '杂合基因型',
          value: 'geneHeterozygous'
        }
      ]
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
